import { React, useContext } from 'react';
import { AuthContext } from '../../services/auth.service';
import { useNavigate } from 'react-router-dom';
import { CompanyLogo } from '../../components/companyLogo';
import localStorageService from '../../services/localStorage.service';
import ReleaseService from '../../services/release.service';
import '../../styles/auth.scss';

export const LogoutPage = () => {
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();

        await logout();
        localStorageService.clearLocalStorage();
        ReleaseService.clearStatus();
        navigate("/login");
    };

    return (
        <div className="auth-container logout-page">
            <div className="bottom-circle"></div>
            <div className="auth-form-container">
                <div className="text-center mb-2">
                    <CompanyLogo />
                </div>
                <h2 className="auth-heading text-center mb-4">Log out</h2>
                <p className="auth-text text-center mb-5">Are you sure you want to log out?</p>
                <form method="post" action="/logout/" onSubmit={handleSubmit}>
                    <button className="auth-button" type="submit">Log out</button>
                </form>
            </div>
        </div>
    );
}
